import { useEffect } from 'react';
import { useParams } from 'react-router';
import { Grid, GridItem, Stack, Text } from '@chakra-ui/layout';
import { useMediaQuery } from '@chakra-ui/media-query';
import { Skeleton } from '@chakra-ui/skeleton';
import { useCrucible } from 'hooks/query/useCrucible';
import { useSelectedCrucible } from 'store/selectedCrucible';
import CrucibleInformation from 'components/explore/CrucibleInformation';
import CrucibleDetailCard from 'components/crucible/detail/CrucibleDetailCard';
import SearchFailed from 'components/explore/SearchFailed';

const ExploreCrucible = () => {
  const { crucibleId } = useParams<{ crucibleId: string }>();
  const { setSelectedCrucible } = useSelectedCrucible();
  const { data: crucible, error: crucibleError } = useCrucible();
  const [isLargerThan992] = useMediaQuery('(min-width: 992px)');

  useEffect(() => {
    if (crucible) {
      setSelectedCrucible(crucible);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crucible]);

  if (crucibleError) {
    return (
      <SearchFailed
        message={
          <Stack
            sx={{
              pb: 4,
              textAlign: 'center',
              wordBreak: 'break-word',
              color: 'whiteAlpha.700'
            }}
          >
            <Text>{`Unable to find Crucbile at ${crucibleId}.`}</Text>
            <Text>Please check you are on the correct network.</Text>
          </Stack>
        }
      />
    );
  }

  return (
    <Grid
      gridTemplateColumns={isLargerThan992 ? '260px 1fr' : '1fr'}
      gap={[4, 4, 8]}
    >
      <Skeleton
        isLoaded={true}
        startColor='gray.700'
        endColor='gray.800'
        borderRadius='xl'
      >
        <GridItem
          bg='gray.800'
          pt={[4, 6, 8, 0]}
          pb={[4, 6, 8, 5]}
          borderRadius='xl'
          height='fit-content'
        >
          {crucible && (
            <CrucibleInformation
              crucibleId={crucible.id}
              owner={crucible.owner}
            />
          )}
        </GridItem>
      </Skeleton>
      <Skeleton
        isLoaded={!!crucible}
        startColor='gray.700'
        endColor='gray.800'
        borderRadius='xl'
      >
        <GridItem bg='gray.800' borderRadius='xl'>
          <CrucibleDetailCard crucible={crucible!} />
        </GridItem>
      </Skeleton>
    </Grid>
  );
};

export default ExploreCrucible;
